import { forwardRef } from 'react';
import PropTypes from 'prop-types';

const ErrorIllustration = forwardRef(function ErrorIllustration({ size = 48 }, ref) {
  return (
    <svg fill="none" height={size} ref={ref} viewBox="0 0 49 48" width={size} xmlns="http://www.w3.org/2000/svg">
      <circle cx="24.5" cy="24" fill="#DF130E" r="24" />
      <path
        clipRule="evenodd"
        d="M30.8132 32L16.5 17.6868L18.1868 16L32.5 30.3132L30.8132 32Z"
        fill="white"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M30.8132 16L16.5 30.3132L18.1868 32L32.5 17.6868L30.8132 16Z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  );
});

ErrorIllustration.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ErrorIllustration;
